export default __webpack_public_path__ + "static/media/rat.2c668b90.png";